<template>
  <div
    class="products_list"
    v-if="productsList.length > 0 || (havePreview && productsList.length <= 0)"
  >
    <div class="tab_box">
      <span
        :class="{ on: current == 1 }"
        class="underwayTab"
        @click="changeTab(1)"
      ></span>
      <span
        v-if="havePreview"
        :class="{ on: current == 2 }"
        class="previewTab"
        @click="changeTab(2)"
      ></span>
    </div>
    <template v-if="hasGetData && productsList.length > 0">
      <van-list class="list">
        <li v-for="item in productsList" :key="item.id" class="list_item">
          <img :src="item.goodsUrl" alt="商品图" class="goods_url" />
          <div class="goods_info">
            <p class="goods_title">{{ item.goodsName }}</p>
            <p class="num_down_box">
              <span class="apply_num">共{{ item.grantSum }}份</span>
              <span v-if="current == 1" class="apply_num"
                >{{ item.applyNum }}人申请</span
              >
              <van-count-down
                v-if="current == 2"
                :time="foramt(item.startTime)"
                class="count_down"
                format="距开始  DD天  HH:mm:ss"
                @finish="getGoodsList"
              />
            </p>
            <p class="goods_price_box">
              <span>
                <span class="goods_price price-num"><i>¥</i>0</span>
                <span class="goods_price_scribing price-num"
                  >￥{{ item.goodsPrice }}</span
                >
              </span>
              <van-button
                :class="{ allow_apply_btn: current == 1 }"
                :disabled="current == 2"
                class="btn"
                @click="current == 1 ? allowApplyHandle(item) : ''"
              >
                {{ current == 1 ? '免费申请' : '未开始' }}
              </van-button>
            </p>
          </div>
        </li>
      </van-list>
      <div v-if="detailParams.haveData" class="cat_more" @click="getMoreData">
        <span>查看更多</span>
        <img
          alt="查看更多"
          src="../../../../assets/images/powderedMilk/xiayiyemore.png"
        />
      </div>
    </template>
    <div
      v-if="current == 1 && hasGetData && productsList.length <= 0"
      class="no_data"
    >
      敬请期待，更多好物正在赶来中～
    </div>
  </div>
</template>
<script>
import Index from './index.js'

export default Index
</script>
<style lang="less" scoped>
@import '../../../../assets/font/font.less';
@import './index.less';
</style>
